// extracted by mini-css-extract-plugin
export default {"container":"modal_container__pX8DU","highPriority":"modal_highPriority__k7Ih4","mainContent":"modal_mainContent__jncg-","animate":"modal_animate__Ky-CU"};